import { HttpService, LoanService, LoanProvider } from '@lk/api'

export const makeLoanService = (http: HttpService, baseUrl: string) => new LoanService(new LoanProvider(http, baseUrl))
